import { css, SerializedStyles } from '@emotion/core';
import { Theme, helpText } from 'features/Theme';

const styles = {
  finePrint: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    margin: ${theme.mui.spacing(1)}px 0 ${theme.mui.spacing(1)}px;
  `,
};

export default styles;
